export const enLocale = {
  theme: {
    day: "2025 RCEP Local Governments and Friendship Cities",
    title: "Cooperation (Huangshan) Forum",
    dateline: "Started",
    unit: "day",
  },
  register: "Group Registration",
  activtyTitle: "Main Activities",
  activtyTitle2: "Visit ROUTE",
  activtyTitle3: "Past Events",
  iForms: {
    close: "Please contact the liaison.",
    website: "Go to Website",
    mainTitle:
      "2025 RCEP Local Governments and Friendship Cities Cooperation (Huangshan) Forum",
    register: "The bulk registration deadline was May 20, 2025.",
    back: "Back",
    title: "Registration Group",
    tellFriend: "Tell Your Friend",
    sTitle: "Foreign Affairs Reception",
    eventMessage: "Registration Method:",
    invitationCode: "Invitation Code:",
    invitUnitAndPeople: "Inviting Organization&Inviter",
    teamclass: "Group Category",
    guestType: "Group Country/Region",
    fromWhere: "Departure Location",
    invitaPlaceHolder: "Please input something",
    unitPlaceHolder: "Inviting Organization",
    peoplePlaceHolder: "Inviter",
    blockName: "Group Information:",
    groupName: "Group Name:",
    persons: "Estimated GroupSize:",
    underTokenPersons: "Courtesy Standard",
    country: "International:",
    attendEvent: "Planned Activities:",

    arriveInfo: "Fill in Arrival and Departure Information",
    arriveWay: "Arrival Method",
    arrivePlace: "Arrival Location",
    departureFlightNumber: "Arrival Flight/Train Number",
    arrivalTime: "Arrival Time",
    leaveWay: "Return Method",
    leavePlace: "Return Location",
    leaveFlightNumber: "Return Flight/Train Number",
    departureTime: "Return Time",
    roomNeed: "Rooms Required",
    roomUnit: "",

    arrivalInfo: "Arrival Information",
    returnInfo: "Return Information",

    attendEvents: {
      label1:
        "RCEP Member Countries and Yangtze River Delta Business Youth Dialogue",
      label2:
        "Dialogue on Cultural and Tourism Cooperation between Friendship Cities of RCEP Member Countries（HEI FEI）",
      label3:
        "Dialogue on Supply-Chain Cooperation in New Energy Vehicle and Photovoltaic Industry between RCEP Member Countries（HE FEI）",
      label4: "Host Country Activities (Mount Huangshan)",
      label5: "Member Countries Qiao Ethnic Dialogue Conference (HE FEI)",
      label6: "2025 RCEP “Huangshan Night",
    },
    eventClick: "Details",
    visitEvent: "Proposed Visit Activity:",
    visitEvents: {
      label1: "Traveling to northern Anhui",
      label2: "Anhui Southern Tour",
    },
    contactPerson: "Group Contact:",
    contactWay: "Contact Information:",
    mainGuests: "Main Guests(Leader):",
    otherGuests: "Others:",
    guestList: {
      title: "Registration Deadline: May 20, 2025, 11:00 PM",
      smallTitle: "Deadline: May 20, 2025",
      guestType: "Rolein Group",
      chineseName: "Chinese Name:",
      englishName: "English Name:",
      country: "Nationality/Region:",
      position: "Position:",
      department: "Organization:",
      contact: "Contact:",
      guestLevel: "Guest Level",
      gender: "Gender",
      cardType: "ID Type",
      certNumber: "ID Number",
    },
    // guestTypeList: {
    //   leader: "Head of Delegation",
    //   vip: "Important Guest",
    //   normal: "Entourage",
    // },
    delete: "Delete",
    addOthers: "Add Group Guest",
    add: "Add",
    activityInfo: "Additional Information",
    otherProblem: "Other Requirements&Questions:",
    otherProblemPlaceHolder: "Multi Line Input",
    submit: "Submit",
    cancel: "Cancel",
    eventMessageSelect: {
      formPeople: "Register with Invitation Code",
      others: "Inviter",
    },
    fromWhereSelect: {
      formPeople: "中国大陆境内/Mainland China",
      others: "其它国家或地区/Areas outside Mainland China",
    },
    contactSelect: {
      phone: "Mainland China Mobile Phone Number",
      email: "Electronic Mail",
      noMessage: "Do Not Receive Event Information",
    },
    modalBtn: {
      cancel: "Cancel",
      confirm: "Confirm",
    },
    rules: {
      join: "Please select registration method.",
      joinInType: "Enter your invitation code.",
      teamclass: "Please select the group category.",
      groupName: "Group name is required",
      persons: "Participants required",
      country: "Please select a country",
      country2: "Please select a nationality/region",
      contactPerson: "Group contact person is required",
      contactWay: "Contact information is required",
      chineseName: "Please enter your Chinese name or English name",
      englishName: "Please enter your Chinese name or English name",
      position: "Please select your position",
      unit: "Please select your organization",
      phone: "Please provide the correct phone number",
      email: "Please fill in the correct email address",
      guestType: "Please select guest level",
      teamType: "Please select the group's country/region",
      planAttendActivity: "Please select at least one activity",
      addGroupClass: "Please add at least one guest",
      underTokenPersons: "Please select the courtesy standard",
      invitUnitAndPeople:
        "Please fill in inviting Inviting Organization&Inviter",
      fromWhere: "Please select departure city",
      selectInviteWay: "Please choose an invitation method",
      inviteWay: "Invitation Method",
      sendSuccessful: "Sent successfully",
      gender: "Please select your gender",
      male: "Male",
      femele: "Female",
      cardType: "Please select the type of ID",
      certNumber: "Please enter the ID number",
    },
    placeholder: {
      teamContactMethod:
        "Only mobile numbers from Mainland China are accepted.",
      teamContactMethod2: "Email",
    },
    guestTypeList: {
      leader: "Group Leader",
      vip: "Important Guest",
      normal: "Entourage",
    },
    activity: {
      name: "Event Name",
      place: "Event Location",
      time: "Event Time",
      action: "Details",
      more: "View",
    },
    tableRule: {
      check: "Check",
      edit: "Edit",
      delete: "Delete",
      action: "Action",
    },
  },
};
